<template>
    <section class="is-fullheight-with-navbar">
      <div v-if="component != 'no-survey'">
        <logo />
        <intro />
        <component :is="component" @form-status="handleEvent" :introText="introText" :startButtonText="startButtonText"></component>
      </div>
       <div v-else>
        <no-survey />
       </div>
      </section>  
</template>

<script>

// import axios from 'axios'
import Logo from '../elements/intro/Logo'
import Intro from '../elements/intro/Intro'
import Start from '../elements/intro/Start'
import Before_start from '../elements/intro/BeforeStart'
import Expired from '../elements/intro/Expired'
import Deleted from '../elements/intro/Deleted'
import Survey from '../layout/Survey'
import SinglePageSurvey from '../layout/SinglePageSurvey'
import Section from '../layout/Section'
import FormSteps from '../elements/footer/FormSteps'
import SubmitForm from '../elements/footer/SubmitForm'
// import EndView from '../elements/EndView'
import SendSuccess from '../elements/SendSuccess'
import NoSurvey from '../elements/intro/NoSurvey'

export default {
  name: 'BasicForm',
  components: {
    'logo': Logo,
    'intro': Intro,
    'start': Start,
    'before_start': Before_start,
    'expired': Expired,
    'deleted': Deleted,
    'survey': Survey,
    'single-page-survey': SinglePageSurvey,
    'form-section': Section,
    'form-steps': FormSteps,
    'submit-form': SubmitForm,
    'send-success': SendSuccess,
    'no-survey': NoSurvey
  },
  data () {
    return {
      // component: 'expired'
      component: this.$store.getters.getStatus,
      surveyType: this.$store.getters.getSurveyType
    }
  },
  methods: {
    // changeActive(index) {
    //   this.$store.commit('setActiveActivity', index);
    //   this.active = index;
        // document.getElementById('activity').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    // },
    handleEvent (type) {
      if (type === 'start') {
        this.$store.commit('setStatus', this.surveyType)
        this.component = this.surveyType
      } 
      if (type === 'sent') {
        this.$store.commit('setStatus', 'send-success')
        this.component = 'send-success'
      }  
    },
    // endSurvey() {
    //   this.component = 'send-success'
    // }
  },
  computed: {
    introText: function () {
      var introText = this.$store.getters.clientStyle.introText;
      if (typeof introText !== undefined && introText != '' && introText != null && introText != 'undefined') return introText;
      return 'De enquête bestaat uit '+ this.$store.getters.getFormLength +' vragen';
    },
    startButtonText: function () {
      var buttonText = this.$store.getters.clientStyle.startButtonText;
      if (typeof buttonText !== undefined && buttonText != '' && buttonText != null && buttonText != 'undefined') return buttonText;
      return 'Start de enquête';
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/templates/BasicForm.vue